import reducer from './reducers';
import * as selectors from './selectors';
import NAMESPACE from './types';

export {
    reducer,
    selectors,
};
export default {
    [NAMESPACE]: reducer,
};
